import { render, staticRenderFns } from "./MiPedido.vue?vue&type=template&id=15f62f45&scoped=true&"
import script from "./MiPedido.vue?vue&type=script&lang=js&"
export * from "./MiPedido.vue?vue&type=script&lang=js&"
import style1 from "./MiPedido.vue?vue&type=style&index=1&id=15f62f45&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15f62f45",
  null
  
)

export default component.exports